import { Skeleton } from "@mui/lab";
import { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { DronerPin } from "./Icons/DronerPin";
import theme from "../styles/theme";
import { DronerSmallCard } from "./DronerCard";
import { meters2ScreenPixels } from "google-map-react";
import { useScreenSize } from "../hooks/useScreenSize";
import { SelectedDroner } from "../lib/context";
import MultipleDronersPin from "./Icons/MultipleDronersPin";

export function ActPositionMarker({ lat, lng }: { lat: number; lng: number }) {
  return (
    <div className="p-relative">
      <Skeleton
        variant="circular"
        sx={{
          bgcolor: "#9dabdb",
          position: "absolute",
          transform: "translate(-50%, -50%)",
        }}
        width={26}
        height={26}
      />
      <Skeleton
        variant="circular"
        sx={{
          bgcolor: "#354eb1",
          position: "absolute",
          transform: "translate(-50%, -50%)",
        }}
        width={14}
        height={14}
      />
    </div>
  );
}

export function HomeMarker({ lat, lng }: { lat: number; lng: number }) {
  return (
    <Box sx={{ border: "2px solid red", position: "relative", zIndex: 20 }}>
      <img
        src="/assets/homeIcon.svg"
        alt="homemarker"
        width={33}
        style={{
          position: "absolute",
          transform: "translate(-50%, -50%)",
        }}
      />
    </Box>
  );
}

export function DronerMarker(props: any) {
  const [freeW, setFreeW] = useState(0);
  const [maxW, setMaxW] = useState(0);
  const [showCard, setShowCard] = useState<boolean>(false);
  const freeDistInM = Number(props.droner.freeDist) * 1000;
  const maxrangeInM = Number(props.droner.maxRange) * 1000;
  const { selectedDroner, setSelectedDroner } = useContext(SelectedDroner);
  const md = useScreenSize("md", "up");
  const sm = useScreenSize("sm", "up");

  useEffect(() => {
    const { w, h } = meters2ScreenPixels(
      freeDistInM,
      { lat: props.droner.lat, lng: props.droner.lng },
      props.zoom
    );
    setFreeW(w * 2);
  }, [freeDistInM, props.droner.lat, props.droner.lng, props.zoom]);

  useEffect(() => {
    const { w, h } = meters2ScreenPixels(
      maxrangeInM,
      { lat: props.droner.lat, lng: props.droner.lng },
      props.zoom
    );
    setMaxW(w * 2);
  }, [maxrangeInM, props.droner.lat, props.droner.lng, props.zoom]);

  return (
    <div className="p-relative">
      <div className="p-absolute bottom-none left-none">
        {selectedDroner?.uid === props.droner.uid && (
          <div>
            <div
              className="center-absolute bg-primary"
              style={{
                width: freeW,
                height: freeW,
                opacity: 0.2,
                borderRadius: "50%",
              }}
            />
            <div
              className="center-absolute bg-primary"
              style={{
                height: maxW,
                width: maxW,
                opacity: 0.2,
                borderRadius: "50%",
              }}
            />
          </div>
        )}

        <div className="p-relative">
          <div
            className="depth-l-1 p-absolute pointer"
            style={{
              zIndex: selectedDroner?.uid === props.droner?.uid ? 1 : 2,
              position: "absolute",
              left: "50%",
              top: "100%",
              transform: "translate(-50%, -100%)",
            }}
            onClick={(e) => {
              // if (!setSelectedDroner || !!selectedDroner) return;
              // setSelectedDroner(props.droner);
              setShowCard(!showCard);
            }}
          >
            <DronerPin
              color={
                selectedDroner?.uid === props.droner?.uid
                  ? theme.palette.secondary.main
                  : // @ts-ignore
                    theme.palette.textColors.main
              }
            />
          </div>
          {/* {selectedDroner?.uid === props.droner?.uid && ( */}
          {showCard && (
            <div
              className={`bg-surface d-block depth-l-4 overflow-hidden rounded-all-normal d-block 
              ${sm ? "center-absolute-horizontal top-large" : "d-none"}`}
              style={{
                maxWidth: 300,
              }}
            >
              <DronerSmallCard
                droner={props.droner}
                handleClickAway={() => {
                  // if (!setSelectedDroner) return;
                  // setSelectedDroner(null);
                  setShowCard(!showCard);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export function MultipleDronerMarker(props: any) {
  const [freeW, setFreeW] = useState(0);
  const [maxW, setMaxW] = useState(0);
  const freeDistInM = Number(props.droner.freeDist) * 1000;
  const maxrangeInM = Number(props.droner.maxRange) * 1000;
  const { selectedDroner, setSelectedDroner } = useContext(SelectedDroner);

  useEffect(() => {
    const { w, h } = meters2ScreenPixels(
      freeDistInM,
      { lat: props.droner.lat, lng: props.droner.lng },
      props.zoom
    );
    setFreeW(w * 2);
  }, [freeDistInM, props.droner.lat, props.droner.lng, props.zoom]);

  useEffect(() => {
    const { w, h } = meters2ScreenPixels(
      maxrangeInM,
      { lat: props.droner.lat, lng: props.droner.lng },
      props.zoom
    );
    setMaxW(w * 2);
  }, [maxrangeInM, props.droner.lat, props.droner.lng, props.zoom]);

  return (
    <div className="p-relative" onClick={props?.onClick}>
      <div className="p-absolute bottom-none left-none">
        <div className="p-relative">
          <div
            className="depth-l-1 p-absolute pointer"
            style={{
              zIndex: selectedDroner?.uid === props.droner?.uid ? 1 : 2,
              position: "absolute",
              left: "50%",
              top: "100%",
              transform: "translate(-50%, -100%)",
            }}
          >
            <MultipleDronersPin value={props.value} />
          </div>
        </div>
      </div>
    </div>
  );
}
